module.exports = __webpack_public_path__ + "img/honor-background.786afb50.png";